import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-page">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg">
            Everything you need to know about using our AllChinaBuy Spreadsheet to find trusted sellers and the best products.
          </p>
        </div>

        <div className="max-w-3xl space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.question}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <summary className="flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-6">
                  {item.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors flex-shrink-0">
                  <i className="ri-add-line text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-4 md:pb-5 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}